export const REQUEST_STATE = {
  STATE_PENDING: 'STATE_PENDING',
  STATE_SUCCESS: 'STATE_SUCCESS',
  STATE_FAILURE: 'STATE_FAILURE',
  STATE_INITIAL: 'STATE_INITIAL',
}

export const MESSAGES_RESPONSE = {
  CURRENT_PAGE: 'current_page',
  DATA: 'data',
  FIRST_PAGE_URL: 'first_page_url',
  FROM: 'from',
  LAST_PAGE: 'last_page',
  LAST_PAGE_URL: 'last_page_url',
  LINKS: 'links',
  NEXT_PAGE_URL: 'next_page_url',
  PATH: 'path',
  PER_PAGE: 'per_page',
  PREV_PAGE_URL: 'prev_page_url',
  TO: 'to',
  TOTAL: 'total',
  UNREAD: 'unread',
}

export default {
  MODULE_ID: 'ws',
  STATUS_REFRESH_INTERVAL: 300,
}
